import { useRef } from 'react';
import { WidgetContainer } from '@/components/analytics/WidgetContainer';
import { BarChart } from '@/components/analytics/charts/BarChart';
import { useChartDimensions } from '@/hooks/useChartDimensions';
import type { QuestionTypeBreakdown } from '@/types/analytics';
import styles from './PerformanceByType.module.scss';

export interface PerformanceByTypeProps {
  data: QuestionTypeBreakdown[] | null;
  isLoading?: boolean;
  error?: Error | null;
}

export function PerformanceByType({ data, isLoading, error }: PerformanceByTypeProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { width } = useChartDimensions(containerRef as any);

  const isEmpty = !data || data.length === 0;

  const chartData = data
    ? data.map((d) => ({
      label: d.questionType.replace('_', ' '),
      value: d.successRate,
      color: 'var(--primary)',
    }))
    : [];

  return (
    <WidgetContainer
      title="Performance by Question Type"
      description="Success rate by question format"
      isLoading={isLoading}
      error={error}
      isEmpty={isEmpty}
      size="medium"
    >
      <div ref={containerRef} className={styles.performanceByType}>
        {width > 0 && (
          <BarChart
            data={chartData}
            width={width}
            height={220}
            horizontal
            showValues
            animate
          />
        )}
      </div>
    </WidgetContainer>
  );
}
